// extracted by mini-css-extract-plugin
module.exports =  {"drawer-absolute-footer-buttons":"UIForm-module__drawer-absolute-footer-buttons___LisNg"};